import React from "react";
import { cn } from "@/lib/utils";

export interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ className, label, error, helperText, ...props }, ref) => {
    return (
      <div
        data-layer="Input/Textarea"
        className={cn(
          "self-stretch flex flex-col justify-start items-start gap-2",
          className,
        )}
      >
        {label && (
          <div
            data-layer="Label"
            className="Label self-stretch justify-start text-Color-Text-neutral-black text-sm font-normal font-['Be_Vietnam_Pro'] leading-5"
          >
            {label}
          </div>
        )}

        <div
          data-layer="Frame 36726"
          className={cn(
            "Frame36726 self-stretch flex-1 p-2 bg-Color-Background-neutral-default_primary rounded-lg border border-Color-Stroke-neutral inline-flex justify-start items-start gap-2.5",
            error && "border-Color-Stroke-negative bg-red-50",
          )}
        >
          <div
            data-layer="Frame 36727"
            className="Frame36727 flex-1 self-stretch flex justify-start items-start gap-1"
          >
            <textarea
              data-layer="Placeholder"
              className="Placeholder flex-1 self-stretch justify-start bg-transparent border-none outline-none text-Color-Text-neutral-black text-sm font-normal font-['Be_Vietnam_Pro'] leading-5 placeholder:text-Color-Text-neutral-supplement resize-none"
              ref={ref}
              {...props}
            />
          </div>
        </div>

        {(error || helperText) && (
          <div
            data-layer="Sub text"
            className={cn(
              "SubText justify-start text-[10px] font-light font-['Be_Vietnam_Pro'] leading-4",
              error
                ? "text-Color-Text-semantic-negative"
                : "text-Color-Text-neutral-supplement",
            )}
          >
            {error || helperText}
          </div>
        )}
      </div>
    );
  },
);

TextArea.displayName = "TextArea";
